import { Command, CommandHandler, HttpService, TaggedUrl, Tags } from '@skylab-shared/core';
import { fillPlaceholders } from '@skylab-shared/utils';

export interface DeleteDashboardNoteParams {
    readonly id: number;
}

export type DeleteDashboardNoteResponse = {
    value: number,
    version: string,
};

export class DeleteDashboardNoteCommand extends Command<DeleteDashboardNoteParams, DeleteDashboardNoteResponse> { }

export class DeleteDashboardNoteCommandHandlerBase implements CommandHandler<DeleteDashboardNoteCommand, DeleteDashboardNoteParams, DeleteDashboardNoteResponse> {
    private static Url = TaggedUrl.join('user/notes/:id', [Tags.Api]);

    public constructor(
        private readonly http: HttpService
    ) { }

    public async handleAsync(cmd: DeleteDashboardNoteCommand): Promise<DeleteDashboardNoteResponse> {
        const { data } = await this.http.delete(fillPlaceholders(DeleteDashboardNoteCommandHandlerBase.Url, { id: cmd.params?.id }));
        return data;
    }
}
